import React, { useState, useEffect } from "react";
import "./styles/MobileMenu.css";
import logo from "../assets/newro-beige-logo.svg";
import { useNavigate } from "react-router";
import { useModal } from "../contexts/ModalContext.js";
import { useAuth } from "../contexts/AuthContext.js";

const MobileMenu = ({ pageOn, handleScroll }) => {
  const { user } = useAuth();
  const { openModal } = useModal();
  const [isOpen, setIsOpen] = useState(false);
  let navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll"); // Add no-scroll class
    } else {
      document.body.classList.remove("no-scroll"); // Remove no-scroll class
    }
  }, [isOpen])


  function navButtonClicked(type) {
    setIsOpen(false);
    switch (pageOn) {
      case "landing":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          handleScroll(type);
        }
        break;
      case "about":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          navigate("/?to=" + type);
          // handleScroll(type)
        }
        break;
      case "event":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          navigate("/?to=" + type);
          // handleScroll(type)
        }
        break;
      default:
        break;
    }
  }

  const displayName = user?.displayName || "Newro User";

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div className="menu-backdrop" onClick={() => toggleMenu()}></div>
      )}
      <nav className="mobile-navbar">
        <div className="navbar-container">
          <div className="logo" onClick={() => navButtonClicked("home")}>
            <img src={logo} alt="logo" className="logo-image" />
            <h1>newro</h1>
          </div>
          <button className="menu-button" onClick={() => toggleMenu()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="menu-icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>

        {/* Dropdown Menu */}
        <ul className={`menu ${isOpen ? "open" : ""}`}>
          <li>
            <a onClick={() => navButtonClicked("home")} href="#home">
              Home
            </a>
          </li>
          <li>
            <a onClick={() => navButtonClicked("connect")} href="#connect">
              Connect
            </a>
          </li>
          <li>
            <a onClick={() => navButtonClicked("about")} href="#about">
              About
            </a>
          </li>
          <li>
            <a onClick={() => navButtonClicked("faq")} href="#about">
              FAQ
            </a>
          </li>
          <li>
            <a onClick={() => navButtonClicked("contact")} href="#about">
              Contact
            </a>
          </li>
          <li>
            {user ? (
              <a onClick={() => openModal("profile")}>Profile</a>
            ) : (
              <a onClick={() => openModal("login")}>Login</a>
            )}
          </li>
        </ul>
      </nav>
    </>
  );
};

export default MobileMenu;
